/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  if ($('.jarallax').length) {
    $('.jarallax').jarallax({
      speed: 0.5,
      imgWidth: 1366,
      imgHeight: 768
    });  
  }
});

/************************** button "add to cart" collection pages **************************/

$('.ad_to_cart_coll').click(function(e){
  var _this7 = this;
  var ID = $(this).attr("data-var_id");
  //addItemToCart( ID, 1 );
  data = {
    "id": ID,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() {
      document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: ID,
                quantity: 1
              }
            }))
    }   
    
  }); 
});


function addItemToCart(variant_id, qty) {
}